import { TrashCan } from "mdi-material-ui";
import React from "react";
import makeConfirmActionDialog from "readmin_pages/shared/makeConfirmActionDialog";

export const AdPresetsDeleteDialog = makeConfirmActionDialog({
  mutationName: "adPresetsDelete",
  action: "Delete Ad Group",
  paramName: "adPresetIds",
  useButtonProps: () => {
    return {
      icon: <TrashCan />,
      content: "Delete",
    };
  },
});
